// extracted by mini-css-extract-plugin
module.exports = {"mediaBlock":"MediaBlock_mediaBlock__kLxM0","caption":"MediaBlock_caption__vE6Rw"};
module.exports.__checksum = "8b8a1ee8efa1"
